import React from "react";

function HeroWeb3() {
  return (
    <div
      className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
      style={{
        background: "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
      }}
    >
      <div className="container">
        <div className="row align-center">
          <div className="col-xl-9 col-lg-8">
            <div className="banner-two-content">
              <h2 className="split-text-right split-text-in-right">
                Web3 Development Services
              </h2>
              <div className="info">
                <p className="fade-up-anim">
                  At Xeer Technology, we offer comprehensive Web3 development
                  services that cater to businesses looking to innovate, create
                  secure and transparent systems & leverage blockchain
                  technology to gain a competitive edge in the digital
                  landscape.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeroWeb3;
